export default __webpack_public_path__ + "static/media/sound-play.b4fc1ae9.png";